import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "navbar-nav w-100 justify-content-between" }
const _hoisted_3 = { class: "nav-link" }

import UserName from './UserName.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'MobileHeader',
  setup(__props) {

  // Components
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(UserName)
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "seperator w-100 col-12" }, null, -1))
  ]))
}
}

})